export default __webpack_public_path__ + "static/media/trickery.f0836836.png";